import { UnifiedConnectionStatus } from "../schemas/organization-unified-connection.schema";

export type OrganizationIntegrationStatus =
    | "connected"
    | "unassigned"
    | "disconnected";

export const ORGANIZATION_INTEGRATION_STATUS_LABELS: Record<
    OrganizationIntegrationStatus,
    string
> = {
    connected: "Connected",
    unassigned: "Unassigned",
    disconnected: "Disconnected",
};

export interface ResolveOrganizationIntegrationStatusParams {
    connectionStatus: UnifiedConnectionStatus;
    isAssigned: boolean;
}

/**
 * Row-level status for one account under a connection. `connection.status` is a
 * connection roll-up — it reports `connected` when any sibling account is
 * assigned — so assignment is re-checked per account. A disconnected connection
 * outranks assignment: it is the more urgent problem, and assignment is moot
 * while the connection is down.
 */
export const resolveOrganizationIntegrationStatus = ({
    connectionStatus,
    isAssigned,
}: ResolveOrganizationIntegrationStatusParams): OrganizationIntegrationStatus => {
    if (connectionStatus === "disconnected") {
        return "disconnected";
    }
    if (!isAssigned) {
        return "unassigned";
    }
    return "connected";
};

/** Most actionable first — the point of grouping or filtering by status. */
export const ORGANIZATION_INTEGRATION_STATUS_ORDER: OrganizationIntegrationStatus[] =
    ["disconnected", "unassigned", "connected"];
